import { call, put, takeLatest } from 'redux-saga/effects';
import apiRequests from 'config/services'; 
import { setElectronicsMpnSearch } from 'store/slices/electronicsMpnSearchSlice';
import { iElectronicsMpnResponse } from 'store/types/electronicsMpnSearch';
import { dataHubTypes, sagaPostElectronicsMpnSearchAction } from 'saga/actions/dataHub';

export function* postElectronicsMpnSearchSaga(
    action: ReturnType<typeof sagaPostElectronicsMpnSearchAction>
  ) {
    try {
      const { manufacturerPartNumber } = action.payload
  
      const response: iElectronicsMpnResponse = yield call(
        apiRequests.postElectronicsMpnSearch,
        manufacturerPartNumber
      )
  
      yield put(setElectronicsMpnSearch(response))
    } catch (e: any) {
     
        yield put(
          setElectronicsMpnSearch({
            status: 422,
            requestId: '',
            type: 'error',
            elapsedTimeMs: 0,
            data: {} as any,
          })
        )
      
    }
  }

export function* toolboxMpnSearchSagaHook() {
  yield takeLatest(dataHubTypes.SAGA_POST_ELECTRONICS_MPN_SEARCH, postElectronicsMpnSearchSaga);
}
